import React from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { alphaNumericspace, formatDateRequire, formatJsonDateToSQL, formatTimeHourMinute } from '../../commonClass/CommonValidation';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import { RoleModel } from '../modals/RightsModel';
import CustomTable from '../../../customControl/CustomTable';
import CommonFilter from '../../../customControl/CommonFilter';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';

const Role = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState<any>({});
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [roledata, setRoleData] = useState<any>([]);
    const [useredit, setUserEdit] = useState(true);
    const [useradd, setUserAdd] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const user = useSelector((store: any) => store.userstatus.tba);
    const [form, setForm] = useState(new RoleModel());
    const [dropDownlist, setDropDownList] = useState<any>([])

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState<any>('All');
    const [serchdisable, setSerachDisable] = useState(false);
    const [filteritems, setFilterItems] = useState([]);

    const handleisActive = (e: any) => {
        if (buttonaddeditText === 'Add') {
            form.IsActive = !form.IsActive
            setFormErrors({});
        }
        else {
            setModalShow(true);
        }
    }
    const handleConfirmation = (e: any) => {
        if (e === true) {
            form.IsActive = !form?.IsActive
            setEditDisabled(true);
            setFormErrors({});
        }
        setModalShow(false);
    }

    //#region bind datatable
    const columns: any = [
        {
            name: 'Department Name',
            key: 'DepartmentName',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (list: any) => list?.DepartmentName
        },
        {
            name: 'Role Name',
            key: 'RoleName',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (list: any) => list?.RoleName
        },
        {
            name: 'TAT',
            key: 'TurnaroundTimeformat',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (list: any) => list?.TurnaroundTimeformat,
            format: (list: any) => list?.TurnaroundTimeformat,
        },
        {
            name: 'Status',
            key: 'Active',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (list: any) => list?.Active
        },
        {
            name: 'Created Date',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: false,
            isExport: false,
            selector: (list: any) => new Date(list?.CreatedOn),
            format: (list: any) => list?.CreatedDate,
        },
        {
            name: 'Edit',
            selector: (list: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' disabled={!useredit || list?.IsReadOnly}><i className="fa-regular fa-pen-to-square" onClick={() => handleEditView(list, 'edit')}></i></button>
        },
        {
            name: 'View',
            selector: (list: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' onClick={() => handleEditView(list, 'view')}><i className="fa-regular fa-eye"></i></button>
        }
    ];

    //#endregion

    //#region handling search

    useEffect(() => {
        dispatch(loaderActions.start());
        getRolelist();
        getroleoptions();
    }, []);

    useEffect(() => {
        let pagelink = user?.find((x: any) => {
            if (x?.PageLink === window.location.pathname)
                return x?.MenuId
        });
        let mid = user?.find((x: any) => x?.MenuId === pagelink?.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter((x: any) => x?.MenuId === pagelink?.MenuId).map((obj: any) => {
            setUserAdd(obj?.URightAdd);
            setUserEdit(obj?.URightEdit);
            setUserExport(obj?.URightExport);

        });
    }, [user])
    //#endregion

    const getRolelist = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            await getAllData('/auth/v1/getallrole?UserType=' + form.UserType).then((roledata) => {
                roledata?.data?.map((obj: any) => {
                    obj.Active = obj.IsActive ? 'Active' : 'InActive'
                    obj.CreatedDate = formatDateRequire(obj?.CreatedOn)
                    obj.TurnaroundTimeformat = formatTimeHourMinute(obj?.TurnaroundTime)
                    return obj;
                })
                setRoleData(roledata.data);
                setFilterItems(roledata.data);
                dispatch(loaderActions.end());
            });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const getroleoptions = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const list = await getAllData('/auth/v1/getroleoptions?UserType=' + form.UserType)
            if (list?.status) {
                const Department = list?.data?.map((obj: any) => ({
                    label: obj?.DepartmentName,
                    value: obj?.DepartmentId,
                }));
                setDropDownList(Department);
            }
            else {
                setDropDownList([]);
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const handleEditView = (data: any, type: any) => {
        setFormErrors({});
        setEditDisabled(false);
        setSerachDisable(true);
        setForm((form: any) => ({
            ...form,
            DepartmentId: data?.DepartmentId,
            RoleId: data?.RoleId,
            RoleName: data?.RoleName,
            TurnaroundTime: data?.TurnaroundTime,
            IsActive: data?.IsActive,
        }))
        setButtonAddEditText("Update");
        if (type === 'edit') {
            setDisabled(false);
        }
        else {
            setDisabled(true);
        }
    }

    const validateData = () => {
        let status: boolean = true;
        const error: any = {}
        if (form?.DepartmentId === 0) {
            error.DepartmentId = "Kindly select Department.";
            status = false;
        }
        if (form?.RoleName?.trim()?.length === 0 && form?.DepartmentId > 0) {
            error.RoleName = "Kindly enter the role name.";
            status = false;
        }

        if (Object.keys(error).length > 0) {
            let id = Object.keys(error)[0];
            let doc = document.getElementById(id);
            if (doc !== null)
                doc.focus();
        }

        setFormErrors(error);
        return status;
    }

    const handleSubmitData = async () => {
        if (validateData()) {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let user: any = GetLocalStorage();
                form.UserId = user?.userMasterID
                const RoleData = buttonaddeditText === 'Add' ? await postUsersData('/auth/v1/insertrole', form)
                    : await patchUsersData('/auth/v1/updaterole', form)
                const status = RoleData.status;
                if (!RoleData.status && !RoleData.data) {
                    dispatch({ type: 'ALERTING', message: RoleData.message });
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
                if (status) {
                    dispatch({ type: 'ALERTING', message: RoleData.message });
                    handleClearClick();
                }
                else {
                    dispatch({ type: 'ALERTING', message: RoleData.message })
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    }

    const onChange = (name: any, val: any) => {
        if (name === "DepartmentId" && val === 0) {
            setForm((form: any) => ({ ...form, [name]: val, RoleName: '' }))
        }
        setForm((form: any) => ({ ...form, [name]: val }))
        setEditDisabled(true);
        setFormErrors({});
    }

    const handleClearClick = () => {
        setButtonAddEditText('Add');
        setDisabled(false);
        setFormErrors({});
        setForm((form: any) => ({
            ...form,
            DepartmentId: 0,
            RoleId: 0,
            RoleName: '',
            TurnaroundTime: null,
            IsActive: false,
        }))
        getRolelist();
        setEditDisabled(true);
        setSerachDisable(false);
        setSerachBy('All');
        setSearchValue('');
    }

    //#endregion

    return (
        <form action="" >
            <div className="mb-1 row mx-1">
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <label htmlFor="DepartmentId" className="col-form-label required">Select Department</label>
                        </div>
                        <div className=" col-lg-8 col-md-12 col-sm-12">
                            <Select
                                inputId='DepartmentId'
                                name='DepartmentId'
                                className='dropdown select_dropdown custom_class'
                                options={dropDownlist}
                                value={dropDownlist?.filter((fil: any) => fil?.value === form?.DepartmentId)}
                                isSearchable={true}
                                closeMenuOnSelect={true}
                                placeholder='Select'
                                onChange={(e: any) => onChange('DepartmentId', (e?.value ? e?.value : 0))}
                                isClearable
                                isDisabled={disabled ? true : false}
                            />
                            {formErrors?.DepartmentId && <div className='text-danger text-start fs_14'>{formErrors?.DepartmentId}</div>}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <label htmlFor="RoleName" className="col-form-label required">Role Name</label>
                        </div>
                        <div className=" col-lg-8 col-md-12 col-sm-12">
                            <input className="form-control"
                                type="text"
                                id='RoleName'
                                name="RoleName"
                                value={form?.RoleName}
                                onChange={(e: any) => onChange("RoleName", alphaNumericspace(e?.target?.value))}
                                disabled={disabled || form?.DepartmentId === 0}
                                placeholder='Role Name'
                                maxLength={35}
                            />
                            {formErrors?.RoleName && <div className='text-danger text-start fs_14'>{formErrors?.RoleName}</div>}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <label htmlFor="inputPassword6" className="col-form-label">Select TAT</label>
                        </div>
                        <div className=" col-lg-8 col-md-12 col-sm-12">
                            <TimePicker
                                id='startTime'
                                className='form-control defo_border'
                                placeholder='--:--'
                                format='HH:mm'
                                value={form?.TurnaroundTime ? dayjs(form?.TurnaroundTime) : null}
                                needConfirm={false}
                                onChange={(e: any) => onChange('TurnaroundTime', e?.$d ? formatJsonDateToSQL(e?.$d) : null)}
                                disabled={disabled}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                        </div>
                        <div className="col-auto col-lg-6">
                            <Switch
                                onChange={handleisActive}
                                checked={form?.IsActive}
                                className="react-switch"
                                disabled={disabled ? true : false}
                            />
                        </div>
                        <ConfirmationModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            noconfirm={() => handleConfirmation(false)}
                            yesconfirm={() => handleConfirmation(true)}
                        />

                    </div>
                </div>
            </div>
            <div className="mt-3 d-flex justify-content-center">
                {useradd === false && buttonaddeditText === "Add" ?
                    <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleSubmitData} disabled={!useradd}>{buttonaddeditText}</button> :
                    <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleSubmitData} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
            </div>
            <CommonFilter
                filtercolumns={columns}
                filteritems={filteritems}
                setFilterList={setRoleData}
                getdata={getRolelist}
                serchdisable={serchdisable}
                setSearchValue={setSearchValue}
                searchvalue={searchvalue}
                setSerachBy={setSerachBy}
                searchby={searchby}
            />
            <CustomTable
                className={"last_two_column_freeze"}
                columns={columns}
                data={roledata}
                PdfExport={false}
                ExportToExcel={false}
                disabled={!userexport}
            />
        </form>
    )
}

export default Role